import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <>
      <style>{`
        .footer {
          background: #0b1124;
          color: #d6e1f5;
          padding: 80px 0 35px;
          font-size: 15px;
        }

        .footer-logo {
          height: 70px;
          margin-bottom: 18px;
        }

        .footer h5 {
          font-weight: 700;
          font-size: 17px;
          margin-bottom: 18px;
          color: #ffffff;
        }

        .footer a {
          color: #c7d3ef;
          text-decoration: none;
          transition: 0.25s ease;
        }

        .footer a:hover {
          color: #ffffff;
          padding-left: 4px;
        }

        .footer .list-unstyled li {
          margin-bottom: 9px;
        }

        .contact-info {
          margin-bottom: 6px !important; /* ⭐ GAP REDUCED */
        }

        .contact-info i {
          color: #4ab3ff;
          margin-right: 10px;
          font-size: 18px;
        }

        .footer-line {
          width: 100%;
          height: 1px;
          background: #22304d;
          margin: 40px 0 25px;
        }

        /* TRUST BADGES */
        .trust-inline {
          display: flex;
          gap: 18px;
          flex-wrap: wrap;
          justify-content: flex-end;
        }

        .trust-inline-item {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #a8c0ea;
          gap: 7px;
        }

        .trust-inline-item i {
          font-size: 18px;
          color: #4ab3ff;
        }

        /* MOBILE FIX */
        @media (max-width: 768px) {
          .footer {
            text-align: center;
            padding: 60px 20px;
          }

          .mobile-two-col-wrapper {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            gap: 20px;
          }

          .mobile-two-col-wrapper > div {
            width: 48%;
            text-align: left;
          }

          .trust-inline {
            justify-content: center;
          }

          .footer-bottom {
            flex-direction: column;
            gap: 15px;
          }
        }
      `}</style>

      <footer className="footer">
        <div className="container">

          <div className="row g-4">

            {/* ⭐ COMPANY INFO */}
            <div className="col-md-4">
              <img src="/footer-logo.png" alt="SWIFTSHIP Logo" className="footer-logo" />
              <p>
                SWIFTSHIP is a U.S.-based logistics company offering secure, technology-driven 
                shipping, warehousing and freight solutions worldwide.
              </p>

              <p className="mt-2">
                Delivering trust, speed & reliability across the globe.
              </p>
            </div>

            {/* ⭐ DESKTOP — SERVICES */}
            <div className="col-md-3 d-none d-md-block">
              <h5>Our Services</h5>
              <ul className="list-unstyled">
                <li><Link to="/services/domestic">Domestic Shipping</Link></li>
                <li><Link to="/services/international">International Freight</Link></li>
                <li><Link to="/services/warehousing">Warehousing</Link></li>
                <li><Link to="/services/e-commercefulfillment">E-commerce Fulfillment</Link></li>
                <li><Link to="/services/customs-clearance">Customs Clearance</Link></li>
                <li><Link to="/services/bulk-freight">Bulk Freight Delivery</Link></li>
              </ul>
            </div>

            {/* ⭐ DESKTOP — LINKS */}
            <div className="col-md-3 d-none d-md-block">
              <h5>Quick Links</h5>
              <ul className="list-unstyled">
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms & Conditions</Link></li>
                <li><Link to="/refund-policy">Refund Policy</Link></li>
                <li><Link to="/shipping-policy">Shipping Policy</Link></li>
                <li><Link to="/payment-policy">Payment & Billing Policy</Link></li>
                <li><Link to="/compliance">Compliance & Data Security</Link></li>
              </ul>
            </div>

            {/* ⭐ MOBILE — TWO COLUMNS */}
            <div className="mobile-two-col-wrapper d-md-none">

              <div>
                <h5>Our Services</h5>
                <ul className="list-unstyled">
                  <li><Link to="/services/domestic">Domestic Shipping</Link></li>
                  <li><Link to="/services/international">International Freight</Link></li>
                  <li><Link to="/services/warehousing">Warehousing</Link></li>
                  <li><Link to="/services/e-commercefulfillment">E-commerce Fulfillment</Link></li>
                  <li><Link to="/services/customs-clearance">Customs Clearance</Link></li>
                  <li><Link to="/services/bulk-freight">Bulk Freight Delivery</Link></li>
                </ul>
              </div>

              <div>
                <h5>Quick Links</h5>
                <ul className="list-unstyled">
                  <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                  <li><Link to="/terms">Terms & Conditions</Link></li>
                  <li><Link to="/refund-policy">Refund Policy</Link></li>
                  <li><Link to="/shipping-policy">Shipping Policy</Link></li>
                  <li><Link to="/payment-policy">Payment & Billing Policy</Link></li>
                  <li><Link to="/compliance">Compliance & Data Security</Link></li>
                </ul>
              </div>

            </div>

            {/* ⭐ CONTACT INFO — WITH ICONS + REDUCED GAP */}
            <div className="col-md-2">
              <h5>Get In Touch</h5>

              <p className="contact-info">
                <i className="bi bi-telephone-fill"></i>
                <a href="tel:4805200274">(480) 520-0274</a>
              </p>

              <p className="contact-info">
                <i className="bi bi-envelope-fill"></i>
                <a href="mailto:info@swiftship.us">info@swiftship.us</a>
              </p>

              <p className="contact-info">
                <i className="bi bi-geo-alt-fill"></i>
                3800 Cabell Dr, Irving, TX 75063, United States
              </p>

              <p className="contact-info">
                <i className="bi bi-clock-fill"></i>
                Mon–Fri: 9:00 AM – 6:00 PM
              </p>
            </div>

          </div>

          <div className="footer-line"></div>

          {/* ⭐ Bottom Row */}
          <div className="d-flex justify-content-between align-items-center footer-bottom">

            <div style={{ color: "#9fb0ce", fontSize: "14px" }}>
              © {new Date().getFullYear()} SWIFTSHIP — All Rights Reserved.
            </div>

            <div className="trust-inline">
              <div className="trust-inline-item">
                <i className="bi bi-shield-lock-fill"></i> SSL Secure
              </div>
              <div className="trust-inline-item">
                <i className="bi bi-credit-card-fill"></i> PCI-DSS Compliant
              </div>
              <div className="trust-inline-item">
                <i className="bi bi-shield-check"></i> AML/KYC Verified
              </div>
              <div className="trust-inline-item">
                <i className="bi bi-patch-check-fill"></i> Authorized U.S. Business
              </div>
            </div>

          </div>

        </div>
      </footer>
    </>
  );
}
